/* Claus Post v2. Native Shopify forms work without JavaScript; this only enhances them. */
(function () {
  'use strict';

  /* Add-to-basket busy state (main button and the sticky bar button). */
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      if (!form.checkValidity()) return;
      document.querySelectorAll('button[name="add"]').forEach(function (button) {
        if (button.form !== form) return;
        button.dataset.label = button.innerHTML;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding to your basket…';
      });
    });
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('button[name="add"][aria-busy="true"]').forEach(function (button) {
      button.removeAttribute('aria-busy');
      if (button.dataset.label) button.innerHTML = button.dataset.label;
    });
  });

  /* Gallery: swipe counter and dots. */
  var slides = document.getElementById('slides');
  if (slides) {
    var count = document.querySelector('[data-count]');
    var dots = Array.prototype.slice.call(document.querySelectorAll('.dots button'));
    var total = slides.children.length;
    var current = function () {
      return slides.clientWidth ? Math.round(slides.scrollLeft / slides.clientWidth) : 0;
    };
    slides.addEventListener('scroll', function () {
      var i = current();
      if (count) count.textContent = (i + 1) + ' / ' + total;
      dots.forEach(function (d, j) {
        d.classList.toggle('on', i === j);
        d.setAttribute('aria-pressed', i === j ? 'true' : 'false');
      });
    }, { passive: true });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        slides.scrollTo({ left: i * slides.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
    });
  }

  /* Enhance the original image links; without JS they still open the full photo. */
  if (slides && window.HTMLDialogElement) {
    var viewer = document.createElement('dialog');
    viewer.className = 'viewer';
    viewer.setAttribute('aria-label', 'Product photographs');
    viewer.innerHTML = '<button type="button" class="viewer-close" aria-label="Close photo">×</button><img alt="">';
    document.body.appendChild(viewer);
    var big = viewer.querySelector('img');
    var photoIndex = 0;
    var photos = [];
    var closeViewer = function () { if (viewer.open) viewer.close(); };
    var showPhoto = function (i) {
      photoIndex = (i + photos.length) % photos.length;
      var a = photos[photoIndex];
      big.src = a.href;
      big.alt = a.querySelector('img') ? a.querySelector('img').alt : '';
    };
    viewer.querySelector('button').addEventListener('click', closeViewer);
    viewer.addEventListener('click', function (e) { if (e.target === viewer) closeViewer(); });
    viewer.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        showPhoto(photoIndex + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });
    var touchStart = null;
    viewer.addEventListener('touchstart', function (e) {
      touchStart = e.touches.length === 1 && (!window.visualViewport || window.visualViewport.scale <= 1) ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
    }, { passive: true });
    viewer.addEventListener('touchcancel', function () { touchStart = null; }, { passive: true });
    viewer.addEventListener('touchend', function (e) {
      if (!touchStart || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - touchStart.x;
      var dy = e.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) showPhoto(photoIndex + (dx < 0 ? 1 : -1));
      else if (Math.abs(dy) > 80 && Math.abs(dy) > Math.abs(dx)) closeViewer();
    }, { passive: true });
    slides.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || !slides.contains(a) || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      photos = Array.prototype.slice.call(slides.querySelectorAll('a[href]'));
      showPhoto(photos.indexOf(a));
      viewer.showModal();
    });
    window.addEventListener('pagehide', closeViewer);
  }

  /* Measure Shopify's own banner, reserving space and lifting the mobile buybar.
     Guard style writes and observe the banner separately to avoid observer loops. */
  if (window.MutationObserver) {
    var banner = null;
    var root = document.documentElement;
    var measureBanner = function () {
      var h = banner && !banner.hidden && getComputedStyle(banner).visibility !== 'hidden' ? Math.ceil(banner.getBoundingClientRect().height) : 0;
      var value = h + 'px';
      if (root.style.getPropertyValue('--cookie-height') !== value) root.style.setProperty('--cookie-height', value);
    };
    var bannerChanges = new MutationObserver(measureBanner);
    var bannerSize = window.ResizeObserver ? new ResizeObserver(measureBanner) : null;
    var findBanner = function () {
      var next = document.getElementById('shopify-pc__banner');
      if (next !== banner) {
        bannerChanges.disconnect();
        if (bannerSize) bannerSize.disconnect();
        banner = next;
        if (banner) {
          bannerChanges.observe(banner, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
          if (bannerSize) bannerSize.observe(banner);
        }
      }
      measureBanner();
    };
    new MutationObserver(findBanner).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', measureBanner);
    window.addEventListener('pageshow', findBanner);
    findBanner();
  }
  function showMedia(mediaId) {
    if (!slides || !mediaId) return;
    var target = slides.querySelector('[data-media-id="' + mediaId + '"]');
    if (!target) return;
    var index = Array.prototype.indexOf.call(slides.children, target);
    if (slides.scrollWidth > slides.clientWidth + 2) {
      slides.scrollTo({ left: index * slides.clientWidth, behavior: 'smooth' });
    } else if (index > 0) {
      slides.insertBefore(target, slides.firstElementChild);
    }
  }

  /* Quantity stepper. */
  document.querySelectorAll('[data-qty]').forEach(function (button) {
    button.addEventListener('click', function () {
      var input = button.parentNode.querySelector('input[name="quantity"]');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(button.dataset.qty, 10);
      input.value = Math.max(1, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* Variant option buttons: switch variant id, price, availability and photo. */
  var form = document.getElementById('letter-order');
  var dataEl = form && form.querySelector('[data-variants]');
  if (form && dataEl) {
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    var idInput = form.querySelector('[data-variant-id]');
    var update = function () {
      var chosen = [];
      form.querySelectorAll('input[data-option-index]:checked').forEach(function (input) {
        chosen[parseInt(input.dataset.optionIndex, 10)] = input.value;
      });
      var variant = variants.filter(function (v) {
        return v.options.every(function (value, i) { return chosen[i] === undefined || chosen[i] === value; });
      })[0];
      var buttons = document.querySelectorAll('[data-add-button]');
      if (!variant) {
        buttons.forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; });
        return;
      }
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      document.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = variant.price; });
      document.querySelectorAll('[data-variant-title]').forEach(function (el) { el.textContent = variant.title; });
      var compare = document.querySelector('[data-compare]');
      if (compare) { compare.textContent = variant.compare || ''; compare.hidden = !variant.compare; }
      buttons.forEach(function (b) {
        b.disabled = !variant.available;
        if (b.id === 'add') {
          b.innerHTML = variant.available ? 'Add to basket · <span data-price></span>' : 'Currently unavailable';
          var span = b.querySelector('[data-price]');
          if (span) span.textContent = variant.price;
        } else {
          b.textContent = variant.available ? 'Add to basket' : 'Unavailable';
        }
      });
      showMedia(variant.media);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url.toString());
      }
    };
    form.querySelectorAll('input[data-option-index]').forEach(function (input) {
      input.addEventListener('change', update);
    });
  }
})();
